import React from "react";
import { useDocument } from "../hooks/firebase";
import { Text, ScrollView } from "react-native";
import styled from "styled-components";

const TOSText = styled(Text)`
  margin: 20px;
  font-size: 17px;
`;

const TOSPage = () => {
  const { value } = useDocument("templates/tos");
  if (!value) {
    return null;
  }
  return (
    <ScrollView>
      <TOSText>{value.en}</TOSText>
    </ScrollView>
  );
};

export default TOSPage;
